import { useLayoutEffect, useState, useRef } from "react";
import { getGlobal } from "../util/getGlobal";
const theGlobal = getGlobal();
export const useElementSize = (delay = 200) => {
    const [size, setSize] = useState(null);
    const ref = useRef(null);
    const handleResize = () => {
        const rect = ref.current?.getBoundingClientRect();
        if (rect)
            setSize({ width: rect.width, height: rect.height });
    };
    let debounceTimeout;
    const debounceHandleResize = () => {
        theGlobal.clearTimeout(debounceTimeout);
        debounceTimeout = theGlobal.setTimeout(handleResize, delay);
    };
    useLayoutEffect(() => {
        theGlobal.requestAnimationFrame(handleResize);
        if (!ref.current)
            return;
        const resizeObserver = new ResizeObserver((_entries) => debounceHandleResize());
        resizeObserver.observe(ref.current);
        return () => resizeObserver.disconnect();
    }, [ref]);
    return [size, ref];
};
